import { Icon, IconProps } from 'design-system';

export const MenuIcon = (props: IconProps) => {
  return (
    <Icon viewBox='0 0 19 14' fill='#757575' {...props}>
      <path d='M0 0H19V2.33333H0V0ZM0 5.83333H19V8.16667H0V5.83333ZM0 11.6667H19V14H0V11.6667Z' fill='inherit' />
    </Icon>
  );
};
